// extracted by mini-css-extract-plugin
export var columnList = "_cz-0";